<template>
	<div class="flex flex-grow">
		<div class="md:gap-1 flex-grow items-baseline">
			<div class="flex">
				<div class="w-full flex" v-if="!isLoading">
					<div class="w-full">
						<div class="flex flex-wrap">
							<BaseInput ref="BaseInput.company.name" :required="true" class="w-full" :label="$t('company')" type="text" v-model="company.name" />
						</div>
						<PersonNameForm ref="PersonNameForm" v-model="company" :show-company="false" />
						<AddressInput v-model="company" />

						<div class="flex flex-wrap">
							<BaseInput
								ref="BaseInput.company.phone"
								:required="true"
								class="w-full md:w-1/2 pr-0 md:pr-2"
								:label="$t('phone')"
								v-model="company.phone"
								type="text"
								validationtype="phone"
							/>

							<BaseInput
								:required="true"
								ref="BaseInput.company.email"
								validationtype="email"
								class="w-full md:w-1/2 pl-0 md:pl-2"
								:label="$t('e_mail')"
								v-model="company.email"
								:error-message="$t('e_mail_not_valid')"
								type="text"
							/>
						</div>
					</div>
				</div>
				<LoadingSpinner v-else />
			</div>
		</div>
	</div>
</template>

<script>
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import Authentication from '@/mixins/Authentication';
import BaseInput from '@/components/forms/inputs/BaseInput.vue';
import AddressInput from '@/components/forms/AddressInput.vue';
import Validate from '@/mixins/Validate';
import PersonNameForm from '@/components/forms/PersonNameForm.vue';

export default {
	components: { PersonNameForm, AddressInput, BaseInput, LoadingSpinner },
	name: 'OnboardingServiceProviderLawyerOffice',
	mixins: [Validate, Authentication],
	data() {
		return {
			isLoading: false,
			company: {
				city: {},
			},
		};
	},
	methods: {
		getData() {
			return this.company;
		},
		clearForm() {
			this.company = { city: {} };
		},
	},
};
</script>
